import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_yebvt","loader":"button__loader_yebvt","secondary":"button__secondary_yebvt","text":"button__text_yebvt","ghost":"button__ghost_yebvt","component":"button__component_yebvt","loading":"button__loading_yebvt","outlined":"button__outlined_yebvt","tertiary":"button__tertiary_yebvt","transparent":"button__transparent_yebvt","link":"button__link_yebvt"};
require('./default.desktop.css')

var styles = {"size-32":"button__size-32_1i96t","size-40":"button__size-40_1i96t","size-48":"button__size-48_1i96t","size-56":"button__size-56_1i96t","size-64":"button__size-64_1i96t","size-72":"button__size-72_1i96t"};
require('./desktop.css')

var invertedColors = {"primary":"button__primary_18bz4","loader":"button__loader_18bz4","secondary":"button__secondary_18bz4","text":"button__text_18bz4","ghost":"button__ghost_18bz4","component":"button__component_18bz4","loading":"button__loading_18bz4","outlined":"button__outlined_18bz4","tertiary":"button__tertiary_18bz4","transparent":"button__transparent_18bz4","link":"button__link_18bz4"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, styles: styles, colorStylesMap: colorStyles }))); });

export { ButtonDesktop };
